import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Box, makeStyles, Paper } from '@material-ui/core';
import { RouteBackground } from 'components';
import { CustomTheme } from 'common/ui/interfaces';
import { PageHeader } from 'common/components';
import commonMessages from 'common/messages/messages';
import useRootSelector from 'common/hooks/useRootSelector';
import { selectIsUserLoggedIn } from 'modules/authentication/state/selectors';
import { selectIsMemberPortalUserLoggedIn } from 'memberPortalModules/authentication/state/selectors';
import TermsOfService from 'modules/privacy-policy/components/TermsOfService/TermsOfService';

const useStyles = makeStyles((theme: CustomTheme) => ({
  paper: {
    padding: '16px',
  },
  header: {
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '16px',
    },
  },
  breadcrumbs: {
    color: theme.palette.text.secondary,
  },
}));

interface ITermsOfServiceContainer {
  onBack?: () => void;
}

const TermsOfServiceContainer: FC<ITermsOfServiceContainer> = ({ onBack }) => {
  const intl = useIntl();
  const classes = useStyles();
  const isClientPortalUserLoggedIn: boolean = useRootSelector(selectIsUserLoggedIn);
  const isMemberPortalUserLoggedIn: boolean = useRootSelector(selectIsMemberPortalUserLoggedIn);
  const isUserLoggedIn = isClientPortalUserLoggedIn || isMemberPortalUserLoggedIn;

  return (
    <RouteBackground>
      <Box maxWidth="666px" margin={isUserLoggedIn ? 'none' : '0 auto'}>
        <PageHeader
          title={intl.formatMessage(commonMessages.termsOfService)}
          onBackButtonClick={onBack}
          className={classes.header}
          spacing={1}
        />

        <Paper className={classes.paper}>
          <TermsOfService />
        </Paper>
      </Box>
    </RouteBackground>
  );
};

export default TermsOfServiceContainer;
